/**
 * WordPress dependencies
 */
import { BaseControl, __experimentalInputControl as InputControl } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
import classNames from 'classnames';

/**
 * Internal dependencies
 */

const InlineInputControl = ({
    instanceId,
    label,
    value,
    onChange,
    help = '',
    placeholder = '',
    type = 'text',
    width = '100px',
    align = 'center'
}) => {
    const id = `input-control-${instanceId}`;

    return (
        <div className="faqmate-control-container">
            <BaseControl label={label} className="faqmate-inline-control-wrapper" id={id}>
                <div
                    className={classNames('faqmate-inline-control', align)}
                    style={{
                        width: width
                    }}
                >
                    <InputControl value={value} onChange={v => onChange(v)} placeholder={placeholder} type={type} id={id} />
                </div>
            </BaseControl>
        </div>
    );
};
export default withInstanceId(InlineInputControl);
